<template>
  <div>
    <!-- Input form dialog -->
    <v-dialog
      v-model="openDialogWatch"
      max-width="500"
      persistent
      no-click-animation
      v-if="!ShowComplete"
    >
      <v-form ref="changePasswordForm" lazy-validation>
        <v-card>
          <v-card-title class="headline backgroundBrand white--text px-4" primary-title>
            {{ $t("ChangePassword") }}
            <v-spacer></v-spacer>
            <v-btn icon dark @click="ClosePasswordResetModal" class="ma-0">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="px-4 pt-6 pb-0">
            <v-alert v-if="errorMessage" type="error" dense text class="mb-4">
              {{ errorMessage }}
            </v-alert>

            <v-text-field
              v-model="currentPassword"
              :label="$t('CurrentPassword')"
              :type="showCurrent ? 'text' : 'password'"
              outlined
              dense
              :rules="[rules.required]"
              :disabled="IsRequesting"
              autocomplete="current-password"
              :append-icon="showCurrent ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showCurrent = !showCurrent"
              class="mb-2"
            />

            <v-text-field
              v-model="newPassword"
              :label="$t('NewPassword')"
              :type="showNew ? 'text' : 'password'"
              outlined
              dense
              :rules="[rules.required, rules.minLength]"
              :disabled="IsRequesting"
              autocomplete="new-password"
              :append-icon="showNew ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showNew = !showNew"
              class="mb-2"
            />

            <v-text-field
              v-model="confirmPassword"
              :label="$t('ConfirmNewPassword')"
              :type="showConfirm ? 'text' : 'password'"
              outlined
              dense
              :rules="[rules.required, rules.matches]"
              :disabled="IsRequesting"
              autocomplete="new-password"
              :append-icon="showConfirm ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showConfirm = !showConfirm"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="ClosePasswordResetModal">
              {{ $t("Cancel") }}
            </v-btn>
            <v-btn
              class="ma-0 ml-2 px-4 backgroundBrand white--text"
              @click="ResetPasswordAction"
              rounded
              :loading="IsRequesting"
            >
              {{ $t("ChangePassword") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Success dialog -->
    <v-dialog
      v-model="openDialogWatch"
      max-width="500"
      persistent
      no-click-animation
      v-else
    >
      <v-card>
        <v-card-title class="headline backgroundBrand white--text" primary-title>
          {{ $t("ActionRequested") }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="ClosePasswordResetModal" class="ma-0">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-3 py-6 text-subtitle-1">
          {{ $t("PasswordChangedSuccess") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            class="ma-0 ml-2 backgroundBrand pa-4 white--text"
            @click="ClosePasswordResetModal"
            rounded
          >
            {{ $t("Ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <UnhandleErrorDialog :openDialog="OpenGeneralError" v-on:CloseErrorOccured="CloseErrorOccured" />
    <NoPermission :openDialog="IsNoPermissionOpen" v-on:CloseNoPermission="CloseErrorOccured" />
  </div>
</template>

<script lang="ts">
import mixins from "vue-typed-mixins";
import Common from "@/Mixins/Common";
import UnhandleErrorDialog from "@/components/UnhandleErrorDialog.vue";
import NoPermission from "@/components/NoPermission.vue";

export default mixins(Common).extend({
  components: {
    UnhandleErrorDialog,
    NoPermission,
  },
  props: {
    openDialog: Boolean,
    TeamMemberId: String,
    ProjectId: String,
  },
  data() {
    return {
      IsRequesting: false,
      openDialogWatch: false,
      ShowComplete: false,
      errorMessage: "",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      showCurrent: false,
      showNew: false,
      showConfirm: false,
      rules: {
        required: (v: string) => !!v || (this as any).$t("REQUIRED"),
        minLength: (v: string) => (v && v.length >= 6) || (this as any).$t("PasswordMinLength"),
        matches: (v: string) => v === (this as any).newPassword || (this as any).$t("PasswordsDoNotMatch"),
      },
    };
  },
  watch: {
    openDialog() {
      this.openDialogWatch = this.openDialog;
      if (this.openDialog) {
        this.reset();
      }
    },
  },
  methods: {
    reset() {
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.errorMessage = "";
      this.ShowComplete = false;
      const form = this.$refs.changePasswordForm as any;
      if (form) form.resetValidation();
    },
    ClosePasswordResetModal() {
      this.reset();
      this.$emit("ClosePasswordResetModal");
    },
    ResetPasswordAction() {
      const form = this.$refs.changePasswordForm as any;
      if (!form.validate()) return;

      this.IsRequesting = true;
      this.errorMessage = "";

      this.$store
        .dispatch("ChangePassword", {
          password: this.currentPassword,
          newPassword: this.newPassword,
          confirmNewPassword: this.confirmPassword,
        })
        .then(() => {
          this.IsRequesting = false;
          this.ShowComplete = true;
        })
        .catch((error: any) => {
          this.IsRequesting = false;
          const status = error?.response?.status;
          if (status === 400) {
            this.errorMessage = (this as any).$t("CurrentPasswordIncorrect");
          } else {
            this.CheckError(error);
          }
        });
    },
  },
});
</script>
